import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/RadioFMTransceiver/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/RadioFMTransceiver/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/RadioFMTransceiver/GetById`, payload),
    Add: (payload) => Repository.post(`/api/RadioFMTransceiver/Add`, payload),
    Edit: (payload) => Repository.post(`/api/RadioFMTransceiver/Edit`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/RadioFMTransceiver/ChangeStatus`, payload),
    Delete: (payload) => Repository.post(`/api/RadioFMTransceiver/Delete`, payload),
}
